import { Helmet } from "react-helmet-async";
import { useLanguage } from "../../i18n/LanguageContext";
import { getSiteOrigin, pageToAbsoluteUrl } from "../../routes";
import { useCatalogI18n } from "../i18n";
import type { Page } from "../types";

const OG_LOCALE: Record<string, string> = {
  ru: "ru_RU",
  kz: "kk_KZ",
  en: "en_US"
};

export function PageSeo({ page }: { page: Page }) {
  const { language } = useLanguage();
  const { copy } = useCatalogI18n();
  const { title, description } = copy.seo[page];
  const url = pageToAbsoluteUrl(page);
  const image = `${getSiteOrigin()}/logo.png`;

  return (
    <Helmet>
      <html lang={language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Baldai" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={OG_LOCALE[language] ?? "ru_RU"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
